import { Box } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import Text from "src/components/Text"
import boostPools from "src/constants/boostPools"
import LockingPeriodRow from "./LockingPeriodRow"

interface SelectPeriodStepProps {
  onSelect: (pid: number) => void
}

const SelectPeriodStep = ({ onSelect }: SelectPeriodStepProps) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Text maxWidth={500} mb={3} mt={1}>
        {t(
          "Your deposit will be held for the duration of the locking period. After the period ends you will be able to withdraw your funds.",
        )}
      </Text>
      {boostPools.map((pool) => (
        <LockingPeriodRow
          {...pool}
          onSelect={() => onSelect(pool.pid)}
          key={pool.pid}
        />
      ))}
    </Box>
  )
}

export default SelectPeriodStep
